import queryString from 'query-string';

export const toQueryParams = (params: any = {}) => {
  const queryParams = Object.assign({}, params);

  return queryString.stringify(queryParams, { arrayFormat: 'bracket', skipNull: true });
};

export const toQueryParamsNestedObject = (obj: any, parentKey: string | null = null): string => {
  const parts: string[] = [];

  const encodeKey = (key: string) => encodeURIComponent(key).replace(/%5B/g, '[').replace(/%5D/g, ']');

  const processValue = (value: any, fullKey: string) => {
    if (value === undefined) {
      return;
    }

    if (Array.isArray(value)) {
      value.flat(Infinity).forEach((item: any) => {
        if (item !== undefined && item !== null) {
          parts.push(`${encodeKey(`${fullKey}[]`)}=${encodeURIComponent(item)}`);
        }
      });
    } else if (typeof value === 'object') {
      parts.push(toQueryParamsNestedObject(value, fullKey));
    } else {
      parts.push(`${encodeKey(fullKey)}=${encodeURIComponent(value)}`);
    }
  };

  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
      continue;
    }
    const fullKey = parentKey ? `${parentKey}[${key}]` : key;
    processValue(obj[key], fullKey);
  }

  return parts.join('&');
};
